/**
 * Convert a ArrayBuffer to a Uint array.
 */
export const arrayBufferToCypher = ab => new Uint8Array(ab);
/**
 * Convert a ArrayBuffer to a string.
 */
export const arrayBufferToString = (buf) => 
//@ts-ignore
String.fromCharCode.apply(null, new Uint8Array(buf));
/**
 * Convert a string to a ArrayBuffer.
 */
export const stringToArrayBuffer = (str) => {
    let buf = new ArrayBuffer(str.length);
    let bufView = new Uint8Array(buf);
    for (let i = 0, strLen = str.length; i < strLen; i++) {
        bufView[i] = str.charCodeAt(i);
    }
    return buf;
};
/**
 * Convert a ArrayBuffer to a binary string.
 */
export const arrayBufferToBinary = (buffer) => {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return binary;
};
/**
 * Convert a hex string to a base64 string.
 */
export const hexToBase64 = hexstring => btoa(hexstring
    .match(/\w{2}/g)
    .map(function (a) {
    return String.fromCharCode(parseInt(a, 16));
})
    .join(''));
/**
 * Convert a blob to a base64 string.
 */
export const blobToBase64 = (blob, callback) => {
    if (!blob || !blob.size || blob.size < 1) {
        return false;
    }
    const reader = new FileReader();
    reader.onload = () => {
        const dataUrl = reader.result;
        // @ts-ignore
        const base64 = dataUrl === null || dataUrl === void 0 ? void 0 : dataUrl.split(',')[1];
        callback(base64);
    };
    reader.readAsDataURL(blob);
};
/**
 * Convert a blob to a base64 string.
 */
export const blobToBase64Async = blob => new Promise((resolve, reject) => {
    if (!blob || !blob.size || blob.size < 1) {
        return reject('Invalid blob or file');
    }
    const reader = new FileReader();
    reader.onload = () => {
        const dataUrl = reader.result;
        if (reader.error)
            reject(reader.error);
        // @ts-ignore
        const base64 = dataUrl === null || dataUrl === void 0 ? void 0 : dataUrl.split(',')[1];
        resolve(base64);
    };
    reader.readAsDataURL(blob);
});
/**
 * Convert a base64 string
 */
export const b64tob64u = a => {
    a = a.replace(/=/g, '');
    a = a.replace(/\+/g, '-');
    a = a.replace(/\//g, '_');
    return a;
};
